import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { BatchManagementClient } from './types';
import * as yup from 'yup';
import { alphanumericRegex, regexOnlyNumber } from 'shell/constants/regex';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.BatchManagementQuery],
  create: [SystemAuthorizations.BatchManagementAdd],
  edit: [SystemAuthorizations.BatchManagementUpdate],
  delete: [SystemAuthorizations.BatchManagementDelete],
});

export const headCells: HeadCell<BatchManagementClient, keyof BatchManagementClient>[] = [
  {
    id: 'id',
    label: 'Nome Batch',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'active',
    label: 'Attivo',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaBatchFilter = yup.object({
  code: yup.string().nullable().notRequired().matches(regexOnlyNumber, 'Il campo è numerico'),
  description: yup
    .string()
    .nullable()
    .notRequired()
    .matches(alphanumericRegex, 'Il campo è alfanumerico'),
});
